import { isBefore, parseISO, startOfDay } from 'date-fns';

import { CALENDAR_EVENT_TYPES } from '@/app/(main)/calendar/consts/calendar-event-types';
import { CALENDAR_TASK_STATUS } from '@/app/(main)/calendar/consts/calendar-task-status';
import type { CalendarEvent } from '@/types/calendarTypes';

export function isPastUnfinishedCalendarTask(event: CalendarEvent, referenceDate = new Date()): boolean {
  if (event.type !== CALENDAR_EVENT_TYPES.TASK_REMINDER) return false;
  if (event.status !== CALENDAR_TASK_STATUS.OPEN) return false;
  if (event.isOverdue) return true;

  const day = startOfDay(parseISO(event.start.slice(0, 10)));
  if (Number.isNaN(day.getTime())) return false;

  return isBefore(day, startOfDay(referenceDate));
}
